import * as React from 'react';
import { PopupProps } from '../../types';
import { Icon, styled } from '@withjoy/joykit';

interface ExitProps {
  onClose: PopupProps['onClose'];
}
const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const ExitButton: React.SFC<ExitProps> = ({ onClose }) => {
  return (
    <Button onClick={onClose}>
      <Icon source="close" />{' '}
    </Button>
  );
};
